<template>
<customdialog v-model="dialog" :maxWidth="options.width" :title="title" :cardtextstyle="'height: 160px;'">

 
  <v-text-field v-model="inputvalue" hide-details :label="message" ></v-text-field>

  <template slot="btn">
    <v-btn color="primary" flat @click.native="yes()">{{btnYesCaption}}</v-btn>
  </template>

</customdialog>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      btnYesCaption: this.$t('OK'),
      inputvalue:'',
      options: {
        color: "primary",
        width: 380,
      }
    };
  },
  components: {
    customdialog
  },
  methods: {
    open(title, message, inputvalue, options) {
      this.btnYesCaption = this.$t('OK')
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.inputvalue = inputvalue;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
   
    yes() {
        this.resolve(this.inputvalue);
        this.dialog = false;
    },
    cancel() {
      this.resolve(null);
      this.dialog = false;
    }
  }
};
</script>
